module.exports = __webpack_public_path__ + "static/media/visacard.50bbb0ca.svg";